import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Blogs } from "../apiPath/api";

export const createBlog = createAsyncThunk(
  "blogs/createBlog",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await Blogs.createBlog(formData);
      return response.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const getAllBlogs = createAsyncThunk(
  "blogs/getAllBlogs",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await Blogs.getAllBlogs(params);
      return response.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const deleteBlog = createAsyncThunk(
  "blogs/deleteBlog",
  async (id, { rejectWithValue }) => {
    try {
      // Adjust API call as per your API utility
      const response = await Blogs.deleteBlog(id);
      return response.data.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const undoDeleteBlog = createAsyncThunk(
  "blogs/undoDeleteBlog",
  async (id, { rejectWithValue }) => {
    try {
      const response = await Blogs.undoDeleteBlog(id);
      return response.data.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const updateBlog = createAsyncThunk(
  "blogs/updateBlog",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Blogs.updateBlog(id, data);
      return response.data.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

const blogSlice = createSlice({
  name: "blogs",
  initialState: {
    loading: false,
    error: null,
    pagination: { total: 0, page: 1, limit: 10, totalPages: 1 },
    statusCounts: { all: 0, active: 0, inactive: 0, deleted: 0 },
    search: "",
    status: "all",
    limit: 10,
    page: 1,
    success: false,
    donorReview: [],
  },

  reducers: {
    resetDonorReviewState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.donorReview = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createBlog.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createBlog.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.createdField = action.payload;
      })
      .addCase(createBlog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getAllBlogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllBlogs.fulfilled, (state, action) => {
        state.loading = false;
        state.blogs = action.payload.data;
        state.pagination = action.payload.pagination;
        state.statusCounts = action.payload.statusCounts;
      })
      .addCase(getAllBlogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteBlog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteBlog.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteBlog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(undoDeleteBlog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(undoDeleteBlog.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(undoDeleteBlog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateBlog.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateBlog.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.updatedField = action.payload;
      })
      .addCase(updateBlog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetBlogState } = blogSlice.actions;
export default blogSlice.reducer;
